import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import { getAwardProofsOptions, useDeleteAwardProof, useUploadOrUpdateAwardProof } from './model/AwardProofModel';

interface AwardProofActionProps {
  awardId: number;
  authors: Author[];
  variant?: 'compact';
}

export function AwardProofAction({ awardId, authors }: AwardProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getAwardProofsOptions(awardId));
  const uploadOrUpdateMutation = useUploadOrUpdateAwardProof(awardId);
  const deleteMutation = useDeleteAwardProof(awardId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="award"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
